import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
const PrivacyPolicyPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/mobile/pages/PrivacyPolicyApp"
    ),
  loading: LoadableLoading
});
const PrivacyPolicyPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/mobile/pages/PrivacyPolicyApp"
    ),
  loading: LoadableLoading
});

class DetectPrivacyPolicy extends Component {
  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <PrivacyPolicyPageMobile />
        ) : (
          <PrivacyPolicyPageDesktop />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    }
  } = state;
  return {
    device: type
  };
};

const PrivacyPolicyHelmet = withTitle({
  component: DetectPrivacyPolicy,
  title: "Medpro | Chính sách bảo mật"
});

export default connect(mapStateToProps)(PrivacyPolicyHelmet);
